import { SimpleMessageService } from '@allbesmart/web-app-common';
import { Component, OnDestroy } from '@angular/core';
import { FormControl, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AvailableRoutes } from 'src/app/enums/available-routes';
import { PostReleaseDto } from 'src/app/models/release/release-dto';
import { ForgeService } from 'src/app/services/forge.service';

@Component({
    selector: 'oaibox-release-create-page',
    templateUrl: './release-create-page.component.html',
    styleUrl: './release-create-page.component.css',
    imports: [ReactiveFormsModule],
})
export class ReleaseCreatePageComponent implements OnDestroy {

  protected releaseCreateForm: ReleaseCreateFormGroup;
  protected ongoingRequest: boolean = false;

  private releaseSubscription?: Subscription;

  constructor(
    private forgeService: ForgeService,
    private simpleMessageService: SimpleMessageService,
    private router: Router,
  ) {
    this.releaseCreateForm = this.getNewReleaseCreateForm();
  }

  private getNewReleaseCreateForm(): ReleaseCreateFormGroup {
    const today = new Date().toISOString().slice(0, 10); // "YYYY-MM-DD"

    return new FormGroup({
      name: new FormControl<string | null>(null, Validators.required),
      date: new FormControl<string | null>(today, Validators.required),
      cn5gTagName: new FormControl<string | null>(null, Validators.required),
      gnbTagName: new FormControl<string | null>(null, Validators.required),
      orchestrationTagName: new FormControl<string | null>(null, Validators.required),
      flexRicTagName: new FormControl<string | null>(null, Validators.required),
      isVisible: new FormControl<boolean | null>(true, Validators.required),
    });
  }

  protected createRelease(): void {
    if (this.releaseCreateForm.invalid) return;

    const createReleaseDto: PostReleaseDto = {
      name: this.releaseCreateForm.value.name ?? undefined,
      releaseDate: this.releaseCreateForm.value.date ?? undefined,
      cn5gTagName: this.releaseCreateForm.value.cn5gTagName ?? undefined,
      gnbTagName: this.releaseCreateForm.value.gnbTagName ?? undefined,
      flexricTagName: this.releaseCreateForm.value.flexRicTagName ?? undefined,
      orchestrationTagName: this.releaseCreateForm.value.orchestrationTagName ?? undefined,
      isVisible: this.releaseCreateForm.value.isVisible ?? undefined,
    };

    this.ongoingRequest = true;
    this.releaseSubscription = this.forgeService
      .createRelease(createReleaseDto)
      .subscribe({
        next: () => {
          this.ongoingRequest = false;
          this.releaseCreateForm = this.getNewReleaseCreateForm();
          this.simpleMessageService.showSimpleMessage({
            message: 'Release created sucessfully!',
            icon: 'fa-solid fa-check-double',
            color: 'success',
          });
          this.goToReleasesPage();
        },
        error: () => {
          this.ongoingRequest = false;
          this.simpleMessageService.showSimpleMessage({
            message: 'Release not created!',
            icon: 'fa-solid fa-triangle-exclamation',
            color: 'danger',
          });
        },
      });
  }

  public goToReleasesPage(): void {
    this.router.navigate([AvailableRoutes.RELEASES]);
  }

  ngOnDestroy(): void {
    this.releaseSubscription?.unsubscribe();
  }
}

type ReleaseCreateFormGroup = FormGroup<{
  name: FormControl<string | null>;
  date: FormControl<string | null>;
  cn5gTagName: FormControl<string | null>;
  flexRicTagName: FormControl<string | null>;
  gnbTagName: FormControl<string | null>;
  orchestrationTagName: FormControl<string | null>;
  isVisible: FormControl<boolean | null>;
}>;
